import OpalPlanningLayout from "./components/OpalPlanningLayout/OpalPlanningLayout";
import OpalCoverageLayout from "./components/OpalCoverageLayout/OpalCoverageLayout";
import OpalDashboardLayout from "./components/OpalDashboardLayout/OpalDashboardLayout";

const AppRoutes = [
  {
    path: 'coverage',
    element: <OpalCoverageLayout />
  },
  {
    path: 'coverage/:id',
    element: <OpalCoverageLayout />
  },
  {
    path: '/planning',
    element: <OpalPlanningLayout />
  },
  {
    path: '/dashboard',
    element: <OpalDashboardLayout />
  }
];

export default AppRoutes;
